const DEFAULT_APP_STORE_URL =
  "https://apps.apple.com/ar/app/barber-app/id6762878422";
const DEFAULT_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.barberAppByCodex.hub&hl=es_AR";
const DEFAULT_CODEX_URL = "https://www.letsbuilditcodex.com/";
const DEFAULT_WHATSAPP_URL =
  "https://wa.me/5493425546393?text=Hola%20quiero%20consultar%20por%20BarberApp";

export const DEFAULT_DOMAIN_BRANDING = {
  siteName: "BarberApp",
  navLogoText: "BarberAppByCodex",
  logoSrc: "/logoBarber.png",
  // Ícono de la pestaña del navegador: recortado y cuadrado para que se vea grande.
  faviconSrc: "/faviconBarber.png",
  bookingPath: "/turnos",
  registerPath: "/registro",
  plansPath: "/planes",
  appStoreUrl: DEFAULT_APP_STORE_URL,
  playStoreUrl: DEFAULT_PLAY_STORE_URL,
  codexBadgeText: "by CODEX®",
  codexBadgeHref: DEFAULT_CODEX_URL,
  footerHref: DEFAULT_CODEX_URL,
  footerTextPrefix: "BarberApp by",
  footerTextStrong: "CODEX®",
  whatsappHref: DEFAULT_WHATSAPP_URL,
  footerLogoSrc: "/logoBlanco.png",
  contactEmail: "barberappbycodex@gmail.com",
  instagramHref: "https://www.instagram.com/",
  tiktokHref: "https://www.tiktok.com/search?q=me%20duele%20la%20cabeza%20meme&t=1783093347969",
  footerCountry: "Argentina",
  // Rubro por defecto de las cuentas que se registran desde este dominio y
  // si el registro muestra el selector de rubro (ShiftHub sí, BarberApp no).
  defaultBusinessType: "barber",
  businessTypeSelect: false,
  // Nav/footer: "Tutoriales" oculto -- Mai está regrabando los videos
  // (quedaron viejos). Volver a poner en true cuando estén los nuevos.
  showTutorials: false,
  // Color de acento del panel hasta que el usuario elige uno (Elegir tema).
  panelDefaultColor: "#ff1493",
  landing: {
    eyebrow: "Sistema de turnos inteligente",
    heroTitle: "Tené control de tu barbería,",
    heroAccent: "cuando quieras y donde quieras 😉",
    heroSubtitle:
      "Reservas online 24/7, notificaciones automáticas y gestión de agenda para vos y tu equipo",
    flowNote: "Todo desde el celular (y la web, si querés 😉)",
    downloadHeading: "¡Descargá la App HOY!",
    primaryCta: "Registrate y activá tu barbería",
    plansTitle: "Elegí el nivel que mejor",
    plansAccent: "acompaña tu barbería.",
    whyTitle: "Todo lo que necesitás,",
    whyAccent: "nada de lo que no.",
    stepsTitle: "En 3 pasos, listo.",
    finalTitle: "¿Listo para dejar de perder turnos?",
    finalSubtitle: "+100 barberías ya usan BarberApp. Unite hoy.",
    // Tarjeta animada del hero: leyenda de la escena "turno en curso" y si
    // se muestran las fotos (son de barbería; otros rubros las ocultan).
    heroClaim: ["¡Vos cortás y Barber App", "hace lo suyo!"],
    heroPhotos: true,
    // Video de "Cómo funciona" (null = la sección no se muestra).
    howVideoSrc: "/videoweb.mp4",
    // Tarjetas de "Clientes del mes" cuando la API no devuelve locales.
    clientCards: null,
    // Captura de "App y web vinculadas".
    vinculadasImageSrc: "/panel-screenshot.jpg",
    vinculadasImageAlt:
      "Panel de administración de BarberApp: turnos, ingresos, QR y accesos rápidos",
    // Punto de salida de cada flecha (01-04) DENTRO de la captura: el borde
    // derecho de cada botón de "Accesos rápidos" (+ Cargar turno / Cargar
    // movimiento / Ver métricas / Registrar venta), medido a mano sobre
    // panel-screenshot.jpg (1200x612) y pasado a fracción del ancho/alto.
    vinculadasArrowOrigins: [
      { x: 1168 / 1200, y: 200 / 612 },
      { x: 1168 / 1200, y: 232 / 612 },
      { x: 1168 / 1200, y: 264 / 612 },
      { x: 1168 / 1200, y: 296 / 612 },
    ],
  },
  checkout: {
    eyebrow: "PLANES BARBERAPP",
    title: "Alta o renovación",
    accent: "de plan.",
    subtitle:
      "Elegí el Plan Pro o ingresá tu cupón, y activá tu cuenta directo desde la web.",
    topBarName: "BarberApp",
  },
  register: {
    eyebrow: "ALTA BARBERAPP",
    title: "Creá tu cuenta",
    accent: "y seguí con el plan.",
    subtitle:
      "Primero registrás tu barbería. Después elegís el plan y completás el pago desde la web.",
    // Los tres pasos que se muestran en el panel rosa (reemplazan al subtítulo).
    steps: [
      "Registrá tu barbería.",
      "Elegí tu plan y completá el pago desde la web.",
      "Ya podés descargar la app y entrar al panel web.",
    ],
    helperTitle: "Qué pasa después",
    helperText:
      "Al terminar este paso te llevamos a la pantalla de planes con el email ya cargado para que sigas con la activación.",
    topBarName: "BarberApp",
  },
  booking: {
    navLogoText: "BarberAppByCodex",
    navBadgeText: "by CODEX®",
    navBadgeHref: DEFAULT_CODEX_URL,
  },
  themeVars: {},
};

export const DOMAIN_BRANDING = {
  // ShiftHub: la misma plataforma para cualquier rubro (estética, salud,
  // etc.). Mismo código, otro dominio, otra base y otro vocabulario.
  "shifthubycodex.com": {
    siteName: "ShiftHub",
    navLogoText: "ShiftHub",
    logoSrc: "/logoWeb.png",
    faviconSrc: "/logoWeb.png",
    footerLogoSrc: "/logoWeb.png",
    appStoreUrl: "https://apps.apple.com/ar/app/shifthub/id6767229780",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.shifthub.pro",
    footerTextPrefix: "ShiftHub by",
    whatsappHref:
      "https://wa.me/543425543308?text=Hola%20quiero%20consultar%20por%20ShiftHub",
    defaultBusinessType: "other",
    businessTypeSelect: true,
    panelDefaultColor: "#39E01F",
    // Todavía no hay videos tutoriales de ShiftHub grabados.
    showTutorials: false,
    landing: {
      eyebrow: "Sistema de turnos inteligente",
      heroTitle: "Tené control de tu negocio,",
      heroAccent: "cuando quieras y donde quieras 😉",
      heroSubtitle:
        "Reservas online 24/7, notificaciones automáticas y gestión de agenda para vos y tu equipo",
      primaryCta: "Registrate y activá tu negocio",
      plansTitle: "Elegí el nivel que mejor",
      plansAccent: "acompaña tu negocio.",
      finalTitle: "¿Listo para dejar de perder turnos?",
      finalSubtitle: "Cientos de negocios ya usan ShiftHub. Unite hoy.",
      heroClaim: ["¡Vos atendés y ShiftHub", "hace lo suyo!"],
      // Las fotos del hero son de barbería: quedan ocultas hasta tener
      // fotos propias de ShiftHub (ver HeroCardShowcase).
      heroPhotos: false,
      // El video muestra la app de BarberApp: sin video por ahora.
      howVideoSrc: null,
      // Sin tarjetas de ejemplo: "Clientes del mes" queda oculto hasta que
      // haya clientes de ShiftHub con logo y portada cargados.
      clientCards: null,
      // Vitrina de locales apagada: por ahora los locales de ShiftHub con
      // logo y portada son de prueba. Borrar esta línea para volver a mostrarla.
      showcaseEnabled: false,
      vinculadasImageSrc: "/panel-screenshot-shifthub.jpg",
      vinculadasImageAlt:
        "Panel de administración de ShiftHub: turnos, ingresos, QR y accesos rápidos",
      // Medido a mano sobre panel-screenshot-shifthub.jpg (1400x804): borde
      // derecho de + Cargar turno / Cargar movimiento / Ir a métricas /
      // Registrar venta (mismo orden que la lista 01-04 de al lado).
      vinculadasArrowOrigins: [
        { x: 1357 / 1400, y: 433 / 804 },
        { x: 1357 / 1400, y: 472 / 804 },
        { x: 1357 / 1400, y: 511 / 804 },
        { x: 1357 / 1400, y: 550 / 804 },
      ],
    },
    // Paleta de ShiftHub sobre el diseño de BarberApp: el verde de la marca
    // para fondos y bordes, uno más oscuro para texto (legible sobre blanco)
    // y el giro de tono que vuelve verde la tarjeta rosa del hero (es PNG).
    themeVars: {
      "--brand": "#39E01F",
      "--brand-rgb": "57, 224, 31",
      "--brand-ink": "#1f9d0e",
      "--brand-hue": "144deg",
      // Hojas de atrás del calendario 3D en negro.
      "--cal-back-1": "#3a3a3a",
      "--cal-back-2": "#1c1c1c",
      // Logo del nav más chico y con aire arriba y abajo.
      "--nav-logo-size": "48px",
      "--nav-logo-margin": "14px",
      "--nav-logo-radius": "12px",
    },
    checkout: {
      eyebrow: "PLANES SHIFTHUB",
      topBarName: "ShiftHub",
    },
    register: {
      eyebrow: "ALTA SHIFTHUB",
      subtitle:
        "Primero registrás tu negocio. Después elegís el plan y completás el pago desde la web.",
      steps: [
        "Registrá tu negocio.",
        "Elegí tu plan y completá el pago desde la web.",
        "Ya podés descargar la app y entrar al panel web.",
      ],
      topBarName: "ShiftHub",
    },
    booking: {
      navLogoText: "ShiftHub",
    },
  },
  "rich-barbershop.com": {
    shopSlug: "rich-barbershop",
    // Web pausada (el cliente no renovó). Muestra un cartel de "no disponible"
    // en vez de la landing. Para reactivarla, poné landingDisabled en false
    // o borrá esta línea.
    landingDisabled: true,
    siteName: "Rich Barbershop",
    logoSrc: "/logoRich.png",
    faviconSrc: "/logoRich.png",
    navLogoText: "Rich Barbershop",
    codexBadgeText: "Reservá online",
    codexBadgeHref: "/turnos",
    footerHref: "/turnos",
    footerTextPrefix: "Sitio de",
    footerTextStrong: "Rich Barbershop",
    contactHref: "https://linktr.ee/richbarbershoprosario/",
    contactLabel: "Linktree",
    instagramHref: "https://www.instagram.com/richbarbershoprosario/",
    linktreeHref: "https://linktr.ee/richbarbershoprosario/",
    addressText: "San Luis 2557, Rosario",
    phoneText: "3413-391929",
    mapsHref:
      "https://www.google.com/maps/place/Rich+Barbershop/@-32.9455565,-60.6614166,17z/data=!3m1!4b1!4m6!3m5!1s0x95b7abf448417741:0xcbcb3778ad2e3a95!8m2!3d-32.9455565!4d-60.6588417!16s%2Fg%2F11zh_z8ftt?entry=ttu&g_ep=EgoyMDI2MDUxMS4wIKXMDSoASAFQAw%3D%3D",
    mapsSrc:
      "https://www.google.com/maps?q=Rich%20Barbershop%20San%20Luis%202557%20Rosario&output=embed",
    customLanding: "rich-barbershop",
    landing: {
      eyebrow: "CORTE Y AFEITADO PREMIUM",
      heroTitle: "RICH",
      heroAccent: "BARBERSHOP",
      heroSubtitle:
        "Barbería clásica con estilo moderno. Cortes, fades y afeitado premium con toallas calientes y navaja, en Rosario centro.",
      primaryCta: "Reservar turno",
      finalTitle: "Reservá tu próxima visita.",
      finalSubtitle:
        "Cálida, premium, vintage y profesional. Una barbería pensada para fidelizar con atención cercana y resultados de primer nivel.",
    },
    checkout: {
      eyebrow: "PLANES RICH BARBERSHOP",
      title: "Activación online",
      accent: "de tu barbería.",
      subtitle:
        "Completá el email de la cuenta y seguí el alta desde este dominio, manteniendo la activación vinculada a Rich Barbershop.",
      topBarName: "Rich Barbershop",
    },
    register: {
      eyebrow: "ALTA RICH BARBERSHOP",
      title: "Creá tu cuenta",
      accent: "y seguí con el alta.",
      subtitle:
        "Registrá tu barbería desde este dominio y continuá el plan sin salir de la experiencia de marca de Rich Barbershop.",
      topBarName: "Rich Barbershop",
    },
    booking: {
      navLogoText: "Rich Barbershop",
      navBadgeText: "Reservas",
      navBadgeHref: "/turnos",
      webPreset: "vintage",
      bannerSrc: "/imgportada.jpeg",
      mobileBannerSrc: "/img2.jpeg",
      logoSrc: "/logoRich.png",
    },
    themeVars: {
      "--pink": "#0C2215",
      "--pink-light": "#C7A45A",
      "--pink-dim": "rgba(199, 164, 90, 0.12)",
      "--pink-border": "rgba(199, 164, 90, 0.28)",
      "--border": "rgba(12, 34, 21, 0.10)",
      "--text": "#0C2215",
      "--text-muted": "#3C4D41",
      "--text-dim": "#7B715C",
      "--font-body": "\"Playfair Display\", serif",
      "--font-display": "\"Playfair Display\", serif",
    },
  },
};

function normalizeHostname(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/:\d+$/, "")
    .replace(/^www\./, "");
}

function normalizeBrandKey(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/\/.*$/, "")
    .replace(/^www\./, "");
}

// Marca fija por build/arranque (npm run start:shifthub / build:shifthub):
// así en local no hace falta el ?brand= y el build de ShiftHub sale marcado.
const ENV_BRAND = process.env.REACT_APP_BRAND || "";

export function resolveDomainBranding(hostname, brandOverride) {
  const normalized = normalizeHostname(hostname);
  const overrideKey = normalizeBrandKey(brandOverride || ENV_BRAND);
  const override =
    DOMAIN_BRANDING[overrideKey] || DOMAIN_BRANDING[normalized] || null;

  if (!override) {
    return {
      ...DEFAULT_DOMAIN_BRANDING,
      landing: { ...DEFAULT_DOMAIN_BRANDING.landing },
      checkout: { ...DEFAULT_DOMAIN_BRANDING.checkout },
      register: { ...DEFAULT_DOMAIN_BRANDING.register },
      booking: { ...DEFAULT_DOMAIN_BRANDING.booking },
      themeVars: { ...DEFAULT_DOMAIN_BRANDING.themeVars },
      hostname: normalized,
      isCustomDomain: false,
    };
  }

  return {
    ...DEFAULT_DOMAIN_BRANDING,
    ...override,
    landing: {
      ...DEFAULT_DOMAIN_BRANDING.landing,
      ...(override.landing || {}),
    },
    checkout: {
      ...DEFAULT_DOMAIN_BRANDING.checkout,
      ...(override.checkout || {}),
    },
    register: {
      ...DEFAULT_DOMAIN_BRANDING.register,
      ...(override.register || {}),
    },
    booking: {
      ...DEFAULT_DOMAIN_BRANDING.booking,
      ...(override.booking || {}),
    },
    themeVars: {
      ...DEFAULT_DOMAIN_BRANDING.themeVars,
      ...(override.themeVars || {}),
    },
    hostname: normalized,
    isCustomDomain: true,
  };
}

// Marca del dominio actual (o de ?brand= / REACT_APP_BRAND). La usan el panel
// y el admin, que no reciben la marca por props como la landing.
let currentBranding = null;
// Dirección pública de la marca del dominio actual (para armar links que se
// comparten: cupones, registro, planes, link de turnos). ShiftHub y BarberApp
// son la misma web con otro dominio: el link tiene que salir con el de cada una.
export function getPublicSiteUrl() {
  return getCurrentBranding().siteName === "ShiftHub"
    ? "https://shifthubycodex.com"
    : "https://barberappbycodex.com";
}

export function getCurrentBranding() {
  if (currentBranding) return currentBranding;
  if (typeof window === "undefined") return resolveDomainBranding("", "");
  let override = "";
  try {
    override = new URL(window.location.href).searchParams.get("brand") || "";
  } catch (_e) {
    override = "";
  }
  currentBranding = resolveDomainBranding(window.location.hostname, override);
  return currentBranding;
}
